export const CONTENT_ID = 'a11y-main-content';
export const INPUT_ID = 'a11y-search-input';
